export const INBOX_UNREAD_COUNT_KEY = "inbox_unread_count";

export const INBOX_TAB_KEYS = {
  DIRECT_MESSAGES: "direct_messages",
  COMMENTS: "comments",
};
export const INBOX_TABS = [
  {
    value: INBOX_TAB_KEYS.DIRECT_MESSAGES,
    label: "Direct messages",
  },
  {
    value: INBOX_TAB_KEYS.COMMENTS,
    label: "Comments",
  },
];

export const INSTAGRAM_INBOX_SYNC_COPY = {
  conversations_syncing_title: "Syncing your Instagram messages",
  conversations_syncing_subtitle:
    "We're importing your Instagram conversations. This may take a few minutes.",
  posts_syncing_title: "Syncing your Instagram posts",
  posts_syncing_subtitle:
    "We're importing your Instagram posts and comments. This may take a few minutes.",
  syncing_ribbon_message: "Instagram Sync in progress — can take up to 2 hours",
};

export const INSTAGRAM_COMMENT_TAB_KEYS = {
  ALL_COMMENTS: "all_comments",
  UNREAD: "unread",
};

export const INSTAGRAM_COMMENT_TABS = ({ totalCount, unreadCount }) => {
  const tabs = [
    {
      value: INSTAGRAM_COMMENT_TAB_KEYS.ALL_COMMENTS,
      label: `All comments (${totalCount})`,
    },
  ];

  if (unreadCount > 0) {
    tabs.push({
      value: INSTAGRAM_COMMENT_TAB_KEYS.UNREAD,
      label: `Unread (${unreadCount})`,
    });
  }

  return tabs;
};
